<template>
	<div class="row">
		<div class="col">
			<h2 class="mb-0">
				<a-icon
					type="code-sandbox"
					class="mr-2"
				/> Proyecto
			</h2>

			<div>
				Especifica el nombre de tu proyecto
			</div>

			<div class="py-4" />

			<form @submit.prevent="check()">
				<a-form-item
					:validate-status="error ? 'error' : ''"
					class="mb-2 text-left"
				>
					<a-input-search
						v-model="project"
						v-focus
						size="large"
						placeholder="CocaCola"
						enter-button=""
						:loading="loading"
						@search="check"
					/>
				</a-form-item>

				<div
					v-show="error"
					class="text-danger animate__animated animate__shakeX"
				>
					{{ error }}
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			project: '',
			error: '',
			loading: false
		};
	},
	computed: {
		validated() {
			if (this.project) return true;
			return false;
		}
	},
	watch: {
		project() {
			this.error = '';
		}
	},
	created() {
		this.project = this.$gestios.project.name;
	},
	methods: {
		async check() {
			if (this.project) {
				this.loading = true;

				const result = await this.$gestios.project.set(this.project);

				if (result.ok) {
					if (this.$app.pack) {
						const pack = this.$app.pack.toLowerCase();
						if (result.data.Parent && result.data.Parent.Slug.toLowerCase() === pack) {
							this.error = '';
							this.$emit('next');
						} else {
							this.error = 'El proyecto no existe o no se puede acceder a el';
						}
					} else {
						this.error = '';
						this.$emit('next');
					}
				} else {
					this.error = 'El proyecto no existe o no se puede acceder a el';
				}

				this.loading = false;
			}
		}
	}
};
</script>

<style module>

</style>
